<template>
    <div class="login">
        <div class="leftMain">
            <span class="title p2"> 智慧巡检系统后台 </span><br />
            <span class="title p3">
                Background of intelligent patrol system
            </span>
        </div>

        <div class="rightMain">
            <div class="fromBox">
                <div class="fromFont">账号密码登录</div>
                <div class="Underline"></div>
                <div class="marginTop">
                    <el-input
                        placeholder="账号"
                        suffix-icon="el-icon-user"
                        v-model="username"
                        @blur="trimBlth('username', username)"
                    >
                    </el-input>
                </div>
                <div
                    class="fromInput"
                    :class="[userFlag ? 'userErrorDeep' : '']"
                >
                    <el-input
                        type="password"
                        ref="passowrdRef"
                        placeholder="密码"
                        suffix-icon="el-icon-lock"
                        v-model="password"
                        v-if="!userFlag"
                        @focus="inputPassWord"
                        @blur="trimBlth('password', password)"
                    >
                    </el-input>
                    <el-input
                        type="password"
                        ref="passowrdRef"
                        placeholder="密码"
                        suffix-icon="el-icon-error"
                        v-model="password"
                        v-if="userFlag"
                        @focus="inputPassWord"
                    >
                    </el-input>
                    <div class="userErr" v-if="userFlag">
                        <img src="../../assets/login/icoError.png" alt="" />
                        账号或密码错误
                    </div>
                </div>
                <div class="btn" @click="login">立即登录</div>
                <div class="tip">
                    注：如果忘记密码，可以用超级管理员账号登录，为其他账号重置密码。
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "login",
    inject:['reload'], // 注入依赖
    data() {
        return {
            // username: "QWE1201",
            // password: "123456",

            username: "",
            password: "",

            userFlag: false,
        };
    },

    mounted() {
        this.reload()
    },

    methods: {
        inputPassWord() {
            this.userFlag = false;
        },

        login() {
            if (!this.username.trim() || !this.password.trim()) {
                return this.$message({
                    type: "warning",
                    message: "账号和密码均不能为空！",
                });
            }

            const loading = this.$loading({
                lock: true,
                text: "正在登录中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 1)",
            });

            let data = {
                username: this.username,
                password: this.password,
            };

            this.request
                .post(this.baseUrl + "account/managerLogin", data)
                .then((res) => {
                    if (res.code == 0 && res.data.token) {
                        // console.log(res.data)
                        // return
                        //存储token
                        let now = new Date();
                        now.setTime(now.getTime() + 1000 * 60 * 60 * 24 * 90);
                        document.cookie =
                            "tokenManage=" +
                            res.data.token +
                            ";expires=" +
                            now.toGMTString() +
                            ";path=/";
                        this.$message({
                            type: "success",
                            message: "登录成功",
                        });
                        let userData = {
                            staffName: res.data.staffName,
                            insName: res.data.insName,
                            lastTime: res.data.lastLoginTime,
                            insExpireTime: res.data.insExpireTime,
                        };
                        localStorage.setItem(
                            "staffNumber",
                            res.data.staffNumber
                        );
                        localStorage.setItem("logo", res.data.insLogo);
                        localStorage.setItem(
                            "userData",
                            JSON.stringify(userData)
                        );
                        localStorage.setItem("userRole", res.data.role)
                        localStorage.setItem("insId", res.data.insId);
                        localStorage.setItem("userId", res.data.userId);
                        localStorage.setItem("staffId", res.data.staffId);
                        this.$router.push("/");
                        setTimeout(() => {
                            this.$router.go(0);
                            setTimeout(() => {
                                loading.close();
                            }, 50)
                        }, 550);
                    } else if (res.code >= 3) {
                        loading.close();
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: "账号或者密码错误，请重试",
                        });
                        this.userFlag = true;
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: "出错了：" + err,
                    });
                });
        },

        trimBlth(type, val) {
            let trimStr = val.trim();
            switch (type) {
                case "username":
                    this.username = trimStr;
                    break;
                case "password":
                    this.password = trimStr;
                    break;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.login {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background: url("../../assets/login/back.png") no-repeat 0 0;
    background-size: 100% 100%;

    .leftMain {
        padding-right: 85px;
        margin-top: 349px;
        width: 1093px;
        text-align: right;
        color: #fff;
        letter-spacing: 2px;
    }

    .rightMain {
        width: 830px;
        .fromBox {
            margin: 356px 0 0 365px;
            width: 240px;
            height: auto;

            .fromFont {
                width: 240px;
                height: auto;
                text-align: left;
                color: rgba(25, 137, 250, 1);
                font-size: 18px;
                line-height: 24px;
                font-weight: 500;
            }

            .fromInput {
                position: relative;
                margin-top: 20px;
                width: 100%;

                .userErr {
                    position: absolute;
                    top: 0;
                    right: -118px;
                    width: 108px;
                    height: 40px;
                    color: rgba(250, 85, 85, 1);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 40px;

                    img {
                        vertical-align: text-bottom;
                        width: 16px;
                        height: 16px;
                    }
                }
            }

            .btn {
                margin-top: 30px;
                width: 240px;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #fff;
                text-align: center;
                background-color: rgba(25, 137, 250, 1);
                cursor: pointer;
            }

            .btn:hover {
                background-color: #66b1ff;
            }

            .tip {
                padding-top: 5px;
                width: 384px;
                height: 22px;
                color: rgba(0, 0, 0, 0.65);
                font-size: 12px;
                line-height: 22px;
                font-weight: 400;
            }
        }
    }

    .RecordNo {
        position: fixed;
        bottom: 2%;
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: rgba(0, 0, 0, .5);

        a {
            color: rgba(0, 0, 0, .5);
            text-decoration: none;
        }
    }
}

.marginTop {
    margin-top: 31px;
}

.userErrorDeep {
    /deep/.el-input__inner {
        border: 1px solid rgba(250, 85, 85, 1);
    }

    /deep/.el-input__icon {
        color: rgba(250, 85, 85, 1);
    }
}

.fromBox > .Underline {
    margin-top: 8px;
    width: 96px;
    height: 2px;
    background-color: rgba(25, 137, 250, 1);
}

.leftMain {
    .p1 {
        font-size: 72px;
        font-weight: 800;
    }

    .p2 {
        font-size: 60px;
        font-weight: 700;
    }

    .p3 {
        font-size: 36px;
        font-weight: 400;
    }
}
</style>